/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 根据projectId获取项目详情信息
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class GetProjectInfoByProjectIdParams {
  constructor(
    public distributionChannelId?: string,
    public distributionSeriesId?: string
  ) {}
}

export default async function (
  projectId: string,

  params: GetProjectInfoByProjectIdParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: good.ProjectDto;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/good/project/detail/old/${projectId}`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
